import { render, staticRenderFns } from "./ChangeForbidden.vue?vue&type=template&id=5e4dad62&scoped=true&"
import script from "./ChangeForbidden.vue?vue&type=script&lang=ts&"
export * from "./ChangeForbidden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dad62",
  null
  
)

export default component.exports